import { Outlet } from "react-router-dom";
import { SideNavProps } from "src/components/layout/SideNav";
import { SideNavLayout } from "src/components/layout/SideNavLayout";

type SideNavLayoutRouteProps = {
  sideNavProps: SideNavProps;
  layoutProps?: Parameters<typeof SideNavLayout>[0]["layoutProps"];
};

/**
 * Pathless data-router layout: existing `SideNavLayout` chrome with `<Outlet />` as the content.
 *
 * Role: data router layout. Prefer this over nesting `<Routes>` inside `SideNavLayout` children.
 * Callers supply `sideNavProps` (typically from domain context). Keeps the `children` API on
 * `SideNavLayout` intact for Storybook and non-router uses.
 */
export function SideNavLayoutRoute(props: SideNavLayoutRouteProps) {
  const { sideNavProps, layoutProps } = props;
  return (
    <SideNavLayout sideNavProps={sideNavProps} layoutProps={layoutProps}>
      <Outlet />
    </SideNavLayout>
  );
}
